import React from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { Box, Container } from '@mui/material';

const Minimal = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        height: '100vh'
        // background: `url(${bg})`,
        // backgroundSize: 'cover'
      }}
    >
      <PerfectScrollbar>
        <Container
          maxWidth="lg"
          sx={{
            height: '100%'
          }}
        >
          {/* <Topbar /> */}

          <Box
            component="main"
            sx={{
              height: '100%'
            }}
          >
            {children}
          </Box>
        </Container>
      </PerfectScrollbar>
    </Box>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;